.root {
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
  background: var(--color-surface-subtle);
}

.conversation {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.centered {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inlineError {
  padding: 10px clamp(16px, 4vw, 48px) 0;
  max-width: var(--content-max-width);
  margin: 0 auto;
  width: 100%;
}
